import React from "react";
import 'react-big-calendar/lib/css/react-big-calendar.css';


//styling
import './Calendar.css'
// constants

// custom components
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PaymentPopperTransaction from "../../accounting/transactions/PaymentPopperTransaction";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import withShipment from "../../../withShipment";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import moment from "moment";
import { Checkbox } from '@material-ui/core';
import { TRANSACTION_INVOICE_PAGE_NAME, BACK } from './constants';


class CarrierInvoiceDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedCarrierInvoiceIds: new Set(),
            selectedFTLInvoiceIds: new Set(),
            selectAll: false,
        }

    }

    handleSelectAllChange = (e) => {
        const { clickedDateEvents } = this.props

        const allCarrierInvoiceIds = []
        const allFTLInvoiceIds = []

        clickedDateEvents.forEach(event => {
            if (event.data.type === 'Carrier') {
                allCarrierInvoiceIds.push(event.data.carrierInvoiceId)
            } else if (event.data.type === 'FTL') {
                 allFTLInvoiceIds.push(event.data.invoiceId)
            }

        });

        if (e.target.checked) {
            this.setState({
                selectedCarrierInvoiceIds: new Set(allCarrierInvoiceIds),
                selectedFTLInvoiceIds: new Set(allFTLInvoiceIds),
                selectAll: true,
            })
        } else {
            this.setState({
                selectedCarrierInvoiceIds: new Set(),
                 selectedFTLInvoiceIds: new Set(),
                selectAll: false,
            })
        }
    }


    formatDollar = (amount) => {
        if (amount === null || amount === undefined || amount === '' || isNaN(amount)) {
          return '-'
        }
        return parseFloat(amount)
          .toFixed(2)
          .toString()
          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    }

    handleCheckboxChange = (event, invoiceId,invoiceType) => {
        const { checked } = event.target;
        const { selectedCarrierInvoiceIds, selectedFTLInvoiceIds } = this.state;

        const newSelectedCarrierInvoiceIds = new Set(selectedCarrierInvoiceIds);
        const newSelectedFTLInvoiceIds = new Set(selectedFTLInvoiceIds);

        if (invoiceType === 'carrier') {
            if (checked) {
                newSelectedCarrierInvoiceIds.add(invoiceId);
            } else {
                newSelectedCarrierInvoiceIds.delete(invoiceId);
            }
        }else if (invoiceType === 'ftl') {
          if (checked) {
            newSelectedFTLInvoiceIds.add(invoiceId);
          } else {
            newSelectedFTLInvoiceIds.delete(invoiceId);
          }
        }


        this.setState({
            selectedCarrierInvoiceIds: newSelectedCarrierInvoiceIds,
            selectedFTLInvoiceIds: newSelectedFTLInvoiceIds,
        });
    };


    render() {

        const {clickedDateEvents} = this.props;
        const {selectedCarrierInvoiceIds,selectedFTLInvoiceIds, selectAll} = this.state;

        const carrierInvoiceIdsArray = Array.from(selectedCarrierInvoiceIds);
         const FTLInvoiceIdsArray = Array.from(selectedFTLInvoiceIds);
        return (
          <>
            <ErrorFeedbackBar />

            {carrierInvoiceIdsArray.length > 0  || FTLInvoiceIdsArray.length > 0 ? (
              <TopToolbar
                pageName={TRANSACTION_INVOICE_PAGE_NAME}
                menuItems={[
                  {
                    title: BACK,
                    icon: <KeyboardBackspaceIcon />,
                    onClick: () => {
                      this.props.handleBack(false);
                    },
                  },
                  {
                    icon: <CreditCardIcon />,
                    disabled: this.props.bankAccounts.length < 1,
                    title: 'Add Payment Method',
                    popper: (
                      <PaymentPopperTransaction
                        bankAccounts={this.props.bankAccounts}
                        selectedCarrierInvoiceIds={carrierInvoiceIdsArray}
                        selectedFTLIds={FTLInvoiceIdsArray}
                      />
                    ),
                  },
                ]}
              />
            ) : (
              <TopToolbar
                pageName={TRANSACTION_INVOICE_PAGE_NAME}
                menuItems={[
                  {
                    title: BACK,
                    icon: <KeyboardBackspaceIcon />,
                    onClick: () => {
                      this.props.handleBack(false);
                    },
                  },
                ]}
              />
            )}

            <h4 style={{ margin: '24px' }}>
              Upcoming Payment Due on{' '}
              {moment
                .utc(clickedDateEvents[0]?.data?.dueDate)
                .format('MMMM D, YYYY')}
            </h4>
            <div className="event-table-container">
              <div className="event-table">
                <table>
                  <thead>
                    <tr>
                      <th style={{ paddingRight: '48px', paddingLeft: '24px' }}>
                        <Checkbox
                          type="checkbox"
                          checked={selectAll}
                          onChange={this.handleSelectAllChange}
                        />
                      </th>
                      <th>Due Date</th>
                      <th>Name</th>
                      <th>Invoice Number</th>
                      <th>Amount Due</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clickedDateEvents.map((event, index) => (
                      <tr key={index}>
                        <td
                          style={{ paddingRight: '48px', paddingLeft: '24px', width:'60px' }}
                        >
                          <Checkbox
                            type="checkbox"
                            checked={
                              selectedCarrierInvoiceIds.has(event.data.carrierInvoiceId) ||
                              selectedFTLInvoiceIds.has(event.data.invoiceId)}
                               onChange={(e) => this.handleCheckboxChange(e,
                              event.data.invoiceId || event.data.carrierInvoiceId, event.data.type.toLowerCase())}
                          />
                        </td>

                        <td>
                          {moment
                            .utc(event.data.dueDate)
                            .format('YYYY-MM-DD')}
                        </td>
                        <td>
                          {event.data.carrierName}
                        </td>
                        <td>{event.data.invoiceNumber}</td>
                        <td
                          style={{
                              textAlign: "right",
                              padding: "5px",
                              paddingRight: "50px",
                              width: "auto"
                          }}
                        >

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center'
                                }}>
                                    <span style={{flexShrink: 0}}>$</span>
                                    <span style={{
                                        marginLeft: '55px',
                                        minWidth: '80px',
                                        textAlign: 'right'
                                    }}>
                                           {
                                               this.formatDollar(event.data.total == null
                                                 ? event.data.invoiceTotal
                                                 : event.data.total)
                                           }
                         </span>
                                </div>

                        </td>
                        <td
                          style={{
                            color:
                              event.data.status === 'Needs Review'
                                ? 'red'
                                : 'inherit',
                          }}
                        >
                          {event.data.status}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        );
    }
}

const mapStateToProps = (state) => ({
    clickedDateEvents: state.calendar.clickedDateEvents,
});


export default withShipment({
    mapStateToProps,
}, CarrierInvoiceDetail);

